import type { DocumentTemplateType, DocumentType } from "@/lib/api";

const TEMPLATE_DOCUMENT_TYPE_MAP: Record<DocumentTemplateType, DocumentType> = {
  contract: "Contract",
  annex: "Annex",
  bank: "Bank Credit",
  court: "Criminal Record",
  sick_leave: "Sick Leave",
  custom: "Other",
};

export function getDocumentTypeForTemplate(
  templateType: DocumentTemplateType,
): DocumentType {
  return TEMPLATE_DOCUMENT_TYPE_MAP[templateType] ?? "Other";
}
